import React, { useContext } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { withAuth, AuthContext } from "./helpers/auth";

import { withModal } from "./webtracking/commons/modal";

import {
  BackOrder,
  Branches,
  BranchOrders,
  Parts,
  PublicBackOrder,
  SignIn,
  Groups,
  BackOrderClient,
} from "./screens";

import EtaRouter from "./eta/EtaRouter";
import UserRouter from "./users/UserRouter";
import InvoiceRouter from "./invoices/InvoiceRouter";
import DashboardRouter from "./dashboard/DashboardRouter";

function App() {
  const auth = useContext(AuthContext);

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/order">
          <BackOrderClient />
        </Route>

        <Route path="/order/:id">
          <PublicBackOrder />
        </Route>

        {!auth.token ? (
          <Route path="/">
            <SignIn />
          </Route>
        ) : null}

        <Route path="/parts/">
          <Parts />
        </Route>

        <Route path="/users">
          <UserRouter />
        </Route>

        <Route path="/eta">
          <EtaRouter />
        </Route>

        <Route path="/branches/:id">
          <BranchOrders />
        </Route>

        <Route path="/branches/">
          <Branches />
        </Route>

        <Route path="/invoices">
          <InvoiceRouter />
        </Route>

        <Route exact path="/backorder/:document">
          <BackOrder />
        </Route>

        <Route exact path="/groups">
          <Groups />
        </Route>

        <Route path="/dashboard">
          <DashboardRouter />
        </Route>

        <Route>
          <Redirect to="/parts" />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}

export default withAuth(withModal(App));
